import axiosInstance from '../axiosInstance';
import { GET_USER_DETAILS } from './config';

export type UserDetails = {
  roles: string[];
  language: string;
};

export const api = {
  async getUserDetails() {
    return axiosInstance.get<UserDetails>(GET_USER_DETAILS);
  },
};

export type GetUserDetailsApi = typeof api;
